import React, { Component } from "react";
import ShopListWidgetWide from './shop_list_widget_wide';
import ShopListWidgetWideDMK from './shop_list_widget_wide_dmk';
import {observer, inject} from 'mobx-react';
import Flexbox from 'flexbox-react';
import HallPanelConnectionAlert from '../alerts/hall_panel_connection_alert';


const shopListPanel = {
	"fontSize": "1.2vh"
};

@inject('RootStore')
@observer
export default class ShopListPanelWide extends Component {

    render() {
        const className = this.props.RootStore.styleStore.currentStylesDict.hallPanelMainBackgroundClassName || '';
        let shopListWidgetWide;
        let displayType = this.props.RootStore.styleStore.currentStyleName;
        if (displayType === 'DMK') {
            shopListWidgetWide = <ShopListWidgetWideDMK/>
        } else if(this.props.RootStore.configStore.displayConnectionIssue) {
            shopListWidgetWide = <HallPanelConnectionAlert alertBoxHeight="70%"/>;
        } else {
            shopListWidgetWide = <ShopListWidgetWide/>;
        }
        return (
          <Flexbox width="71.5%" height="100%" className={className} style={shopListPanel}>
              {shopListWidgetWide}
          </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/food_court_shop_list_panel/shop_list_panel_wide.jsx